<template>
  <transition name="fade">
    <div class="event-page" id="event-fullpage">
      <section class="event-landing section">
        <div class="main-container">
          <div class="logo-text">
            <img src="../assets/gs-logo.png">
            <div class="text">X</div>
            <img src="../assets/gp-logo.png">
            <div class="text"></div>
          </div>

          <div class="flex-container">
            <div class="img-circle">
              <img src="../assets/blitz_1.jpg" alt="">
            </div>
            <div class="text-container">

              <div class="item-group">
                <div class="question">什么是闪电扩张？</div>
                <div class="answer">
                 闪电扩张是指初创公司在发展过程中，优先考虑速度，快速扩大规模，在短短几年内从零增长到数十亿美元的市场领导者；或在大型的全球公司中迅速扩展现有的项目或业务部门。我们为公司提供咨询服务和计划、定制化内容、数据和研究驱动的产品，让其迅速扩大规模和提升创新能力。
                </div>
              </div>
              <div class="item-group">
                <div class="question">
                 全球扩张学院能够做什么？</div>
                <div class="answer">
                  全球扩张学院（GSA）的成立旨在与全球创始人分享来自硅谷的扩张经验。我们的合作伙伴、导师和扩展专家主要由来自硅谷的高管组成，他们具有跨行业、跨商业模型和跨功能领域学科扩展科技创业公司的经验。<a href="http://www.globalscalingacademy.com" target="_blank">www.globalscalingacademy.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="event-intro section">
        <div class="main-container">
          <div class="blitz-item">
            <div class="profile">
              <img src="../assets/Chris.png">
            </div>
            <div class="about-info">
              <div class="question">
                 克里斯·叶
              </div>
              <div class="answer">
                   克里斯·叶是全球扩张学院的联合创始人，指导个人和团队规划和实现高速增长。自1995年以来，克里斯已创办、投资并为100多家高科技初创公司提供了咨询服务，其中包括Ustream（兼顾投资人、顾问、首席执行官）和UserTesting.com（顾问）等价值数以亿计的公司。他与里德·霍夫曼共同编著了《闪电扩展：建设高价值公司的快速通道》，同时与里德·霍夫曼及本·卡斯诺查共同编著了《纽约时报》的畅销书《联盟：互联网时代的人才变革》。克里斯以优异的成绩获得了斯坦福大学双学位，并从哈佛大学商学院获得了MBA学位，同时被授予了贝克学者的称号。
              </div>
            </div>
          </div>

          <div class="blitz-item">
            <div class="profile">
              <img src="../assets/Jeff.png">
            </div>
            <div class="about-info">
              <div class="question">
                  杰弗里·艾勃特
              </div>
              <div class="answer">
                杰弗里·艾勃特是全球扩张学院的联合创始人兼执行合伙人。他积极参与全球生态系统的开发，曾指导数百家初创企业，并担任亚利桑那州立大学（美国创新排名第一）的创业加速课程的领导、欧洲创新学院的首席导师以及卡塔尔科学技术园、ScaleIT、北欧创新、创业智利等机构的导师。杰弗里在企业创新和创业方面具有20多年的经验，他牵头全球扩张学院与Valuer.ai建立合作关系，Valuer.ai致力于为不断扩张的初创企业寻找合作伙伴。杰弗里曾担任通用电气在拉丁美洲的数字营销和电子商务创始总监，并自此进入了科技行业。当时，他促成了价值20亿美元的业务的数字化转型，创立并扩展了拉丁美洲最大的在线家电商店Tienda Mabe，第一年销售额就超过2000万美元。杰弗里拥有伊利诺伊大学的学士学位和雷鸟全球管理学院的管理学硕士学位，精通5种语言，曾在美国、欧洲和拉丁美洲生活和工作。
              </div>
            </div>
          </div>
        </div>

      </section>

      <section class="main-container event-signup section fp-noscroll fp-auto-height-responsive" id="event-signup">
        <div class="flex-container">
          <div class="col-35 fade-in" v-view>
            <div class="headline-3">
              快来加入下一届闪电扩张训练营吧。
            </div>
          </div>
          <div class="col-65">
             <div class="circle-img">
               <img src="../assets/blitz.png" alt="">
                <a href="mailto:inquiry@greenprosperitygroup.com" class="signup">获取最新进展</a>
             </div>
          </div>
        </div>
        <GPFooter />
      </section>
    </div>
  </transition>
</template>
<style lang="scss" src="./BlitzPage.scss"></style>

<script>
import Fullpage from 'fullpage.js'
export default {
  name: 'BlitzPage',
  props: {
  },
  data () {
    return {
      eventSliders: null
    }
  },
  methods: {
    initFullPage () {
      this.eventSliders = new Fullpage('#event-fullpage', {
        licenseKey: 'FAE6D29E-C9664B70-A1915489-3CEF9EF7',
        autoScrolling: true,
        lazyLoading: true,
        easingcss3: 'cubic-bezier(0.75, 0, 0.25, 1)',
        fitToSectionDelay: 180,
        fadingEffect: false,
        animateAnchor: false,
        scrollingSpeed: 800,
        scrollBar: true,
        navigation: true,
        navigationPosition: 'left',
        afterResize: (width, height) => {
          if (width < 1024) {
            this.eventSliders.destroy('all')
            this.eventSliders = null
          }
        }
      })
    },
    resizeEvent (e) {
      e.stopPropagation()
      if (document.body.offsetWidth > 1024 && this.eventSliders === null) {
        this.initFullPage()
      }
    }
  },
  destroyed () {
    if (this.eventSliders !== null) {
      this.eventSliders.destroy('all')
      this.eventSliders = null
    }
    window.removeEventListener('resize', this.resizeEvent)
  },
  created () {
  },
  mounted () {
    window.addEventListener('resize', this.resizeEvent)
    if (document.body.offsetWidth > 1024 && this.eventSliders === null) {
      this.initFullPage()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/BlitzPage.vue